import type { LalSegmentApi } from '@openx/types/segments';
import { LalSegmentDetailsSection } from './sections/LalSegmentDetailsSection';
import { LalSegmentOwnerSection } from './sections/LalSegmentOwnerSection';
import { LalSegmentReachSection } from './sections/LalSegmentReachSection';
import { LalSegmentSeedsSection } from './sections/LalSegmentSeedsSection';

export const LalSegmentDetails = ({ lalSegment }: { lalSegment: LalSegmentApi }) => {
  return (
    <>
      <LalSegmentReachSection lalSegment={lalSegment} />
      <LalSegmentDetailsSection lalSegment={lalSegment} />
      <LalSegmentSeedsSection lalSegment={lalSegment} />
      <LalSegmentOwnerSection organizationName={lalSegment.account?.name} providerName={lalSegment.provider?.name} />
    </>
  );
};
